export const SET_PORTFOLIO_DATA = 'SET_PORTFOLIO_DATA';
export const SET_COMPANY_DETAILS = 'SET_COMPANY_DETAILS';
export const SET_ASSETS_DETAILS = 'SET_ASSETS_DETAILS';
export const SET_TOKEN_PITCHES = 'SET_TOKEN_PITCHES';
